import React from 'react';
import { StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import CreditDisplayCard from '@/components/Credits/CreditDisplayCard';

const styles = StyleSheet.create({
  sectionContainer: {
    width: '100%',
  },
  sectionHeader: {
    marginBottom: 15,
  },
  sectionSubtitle: {
    marginVertical: 5,
  },
});

function PurchasedCreditsSection({ credits }) {
  return (
    <View style={styles.sectionContainer}>
      <View style={styles.sectionHeader}>
        <Text color="primary" size='xl' weight='bold'>
          Purchased Credits
        </Text>
        <Text style={styles.sectionSubtitle} size="n" color="secondary">
          Additional credits you've purchased
        </Text>
      </View>
      
      <CreditDisplayCard
        icon="coins"
        credits={credits}
        text="Available credits"
      />
    </View>
  )
}

export default React.memo(PurchasedCreditsSection);